
























import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import { Section } from "@/types";

export default Vue.extend({
  name: "NavigationBar",
  computed: {
    ...mapGetters("navigation", ["getSections", "getActiveSection"])
  },
  methods: {
    ...mapActions("navigation", ["setActiveSection", "setIsStepFading"]),
    setCurrentSection: function(section: Section) {
      this.setIsStepFading(true);

      setTimeout(() => {
        this.setActiveSection(section);
        this.setIsStepFading(false);
      }, 350);
    }
  }
});
